import { render, staticRenderFns } from "./video-popbox.vue?vue&type=template&id=6ef386da&comments=true&"
import script from "./video-popbox.vue?vue&type=script&lang=js&"
export * from "./video-popbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports